import actionTypes from './ActioTypes';
import request from '../../utils/request';
import apiSettings from '../../config/api';

const buy = (data) => {
  return dispatch => {
    const url = apiSettings.endpoints.genCreateOrder();
    return request
      .post(url, data, dispatch, actionTypes.CREATE_ORDER)
      .then((res) => {
        if (res.data && res.data.url) {
          window.location.href = res.data.url;
        }
        console.log(res)
      })
  }
};

export {buy}


// WEBPACK FOOTER //
// ./src/app/containers/Booking/Actions.js